<template>
  <v-dialog v-model="dialog" width="600px" scrollable :fullscreen="$vuetify.breakpoint.smAndDown">
    <v-card>
      <v-card-title class="blue darken-4 white--text text-uppercase">
        <v-toolbar-title>SỬA chương trình đào tạo</v-toolbar-title>
        <v-spacer />
        <v-icon color="white" @click="cancel">close</v-icon>
      </v-card-title>
      <v-card-text>
        <v-divider></v-divider>
        <v-form ref="form">
          <v-text-field
            outlined
            dense
            v-model="title"
            class="required mt-4"
            :rules="[$rules.required, titleRule]"
            label="Tên chương trình đào tạo"
          />
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="d-flex justify-space-between pa-6">
        <v-btn class="text-none text-uppercase" outlined @click="cancel">Huỷ</v-btn>
        <v-btn color="primary text-none text-uppercase" elevation="0" :loading="loading" @click="save">Lưu</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import { textHelpers } from '@/helpers/TextHelper.js'
export default {
  props: {
    state: Boolean,
    division: { type: Object, default: () => {} },
    type: { type: String, default: 'create' },
  },
  data() {
    return {
      dialog: false,
      loading: false,
      title: '',
      academicLevel: {},
      titleRule: (v) => {
        const title = textHelpers.removeSpaces(v)
        const d = this.divisions.find((d) => d.title === title && d.academicLevel.id === this.academicLevel.id)
        return !d || 'Chương trình đào tạo này đã tồn tại'
      },
    }
  },
  created() {
    if (this.division) {
      this.title = this.division.title
      this.academicLevel = this.division.academicLevel
    }
  },
  computed: {
    ...mapState({
      divisions(state) {
        return state['division'].divisions
      },
      academicLevels(state) {
        return state['AcademicLevel'].academics
      },
    }),
  },
  methods: {
    ...mapActions('division', ['updateDivision']),
    async save() {
      if (!this.$refs.form.validate()) return
      try {
        this.loading = true
        await this.updateDivision({ id: this.division.id, title: this.title })
        this.$alert.updateSuccess()
        this.dialog = false
      } catch (error) {
        this.$alert.updateError()
      } finally {
        this.loading = false
      }
    },
    reset() {
      this.title = ''
      this.$refs.form.resetValidation()
    },
    resetValidation() {
      this.$refs.form && this.$refs.form.resetValidation()
    },
    cancel() {
      this.dialog = false
      this.reset()
    },
  },
  watch: {
    state() {
      this.dialog = true
    },
    academicLevel: 'resetValidation',
  },
}
</script>
